import type { SeasonCheckboxes } from "../components/dashboard/utils/types";

import axios from "axios";
import { API_ROOT } from ".";
import { getAuthUser } from "./auth";

const SEASON_API_URL = `${API_ROOT}/season`;

export enum ApplicationPeriod {
  PreviousCSA = "previous-csa",
  Waitlisted = "waitlisted",
  FreeForAll = "free-for-all",
  ApplicationClosed = "application-closed",
}

export interface Season {
  id: string;
  areWeInSeason: boolean;
  isBusinessOpen: boolean;
  applicationPeriod: ApplicationPeriod;
  freeDeliveryThreshold: number;
  businessDeliveryPrice: number;
  csaDeliveryPrice: number;
  checkboxes: SeasonCheckboxes;
  waitlist: string[];
  createdAt?: string;
  updatedAt?: string;
}

export async function callFetchSeason(): Promise<Season> {
  const res = await axios.get<Season>(SEASON_API_URL);
  return res.data;
}

export interface UpdateSeasonPayload {
  areWeInSeason?: boolean;
  isBusinessOpen?: boolean;
  applicationPeriod?: ApplicationPeriod;
  freeDeliveryThreshold?: number;
  businessDeliveryPrice?: number;
  csaDeliveryPrice?: number;
  checkboxes?: SeasonCheckboxes;
  waitlist?: string[];
}

export async function callUpdateSeason(
  id: string,
  data: UpdateSeasonPayload,
): Promise<Season> {
  const res = await axios.put<Season>(`${SEASON_API_URL}/${id}`, data);
  return res.data;
}

export type JoinSeasonWaitlistResult = {
  waitlist: Season["waitlist"];
  alreadyOnWaitlist: boolean;
};

export async function callJoinSeasonWaitlist(): Promise<JoinSeasonWaitlistResult> {
  const token = getAuthUser()?.token;
  if (!token) throw new Error("Not authenticated");

  const res = await axios.post<{
    waitlist: string[];
    alreadyOnWaitlist?: boolean;
    message?: string;
  }>(
    `${SEASON_API_URL}/waitlist`,
    {},
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return {
    waitlist: res.data.waitlist,
    alreadyOnWaitlist: res.data.alreadyOnWaitlist === true,
  };
}
